document.addEventListener("livewire:load", function () {
    addImageHoverFunctionality();
});

document.addEventListener("livewire:update", function () {
    addImageHoverFunctionality();
});

function addImageHoverFunctionality() {
    const cards = document.querySelectorAll("#custom_product_card");
    cards.forEach((card) => {
        const imageContainer = card.querySelector(".image-container");
        const defaultImg = card.querySelector(".default-image");
        const hoverImg = card.querySelector(".hover-image");
        const quantity = card.getAttribute("data-quantity");
        const isOutOfStock = quantity == 0;
        if (isOutOfStock) {
            imageContainer.classList.add("opacity-50");
        }
        if (hoverImg) {
            card.addEventListener("mouseover", () => {
                defaultImg.style.opacity = 0;
                hoverImg.style.opacity = 1;
            });
            card.addEventListener("mouseout", function () {
                defaultImg.style.opacity = 1;
                hoverImg.style.opacity = 0;
            });
        }
    });
}
